import type { ComputedRef, CSSProperties, InjectionKey } from 'vue'

export interface DescriptionContext {
  column: number
  colon: boolean
  labelStyle?: CSSProperties
  contentStyle?: CSSProperties
}
export const descriptionsKey: InjectionKey<ComputedRef<DescriptionContext>> = Symbol('rrDescriptions')
